import { pipe } from 'fp-ts/function';
import { array, option, record } from 'fp-ts';
import {
    CheckInConfiguration,
    CheckInConfigurationUpdate,
    CheckInConfigurationValue,
} from '@mews-commander/data-access';
import { keyBy } from '@mews/fp';
import { CheckInCheckboxStates, CheckInFieldsValues } from '../types';
import { configurationTypeSections } from '../sections';

interface ConvertTableValuesToUpdatesOptions {
    tableValues: CheckInFieldsValues;
    configurations: CheckInConfiguration[];
    checkboxStates: CheckInCheckboxStates;
    areExtendedHotelConfiguredFieldsEnabled: boolean;
}

const getValue = (formValue: CheckInConfigurationValue, checked: boolean) =>
    checked ? formValue : CheckInConfigurationValue.DoNotShow;

export const convertTableValuesToUpdates = ({
    tableValues,
    configurations,
    areExtendedHotelConfiguredFieldsEnabled,
    checkboxStates,
}: ConvertTableValuesToUpdatesOptions): CheckInConfigurationUpdate[] => {
    const configByType: Record<string, CheckInConfiguration> = keyBy('type', configurations);

    return pipe(
        record.toEntries(tableValues),
        array.filterMap(([key, { reservationAdult, reservationChild, reservationOwner }]) => {
            const config = configByType[key];

            const tabItem = configurationTypeSections[key] ?? null;
            const checkbox = tabItem ? checkboxStates[tabItem] : undefined;

            return option.some({
                id: config.id,
                type: config.type, // Useful for quick reference.
                reservationOwnerValue: { value: reservationOwner },
                reservationAdultValue: areExtendedHotelConfiguredFieldsEnabled
                    ? { value: getValue(reservationAdult, checkbox?.reservationAdult ?? true) }
                    : null,
                reservationChildValue: areExtendedHotelConfiguredFieldsEnabled
                    ? { value: getValue(reservationChild, checkbox?.reservationChild ?? true) }
                    : null,
            });
        })
    );
};
